
export const METRONOME_WORKER_CODE = [
  '"use strict";',
  'var timerID = null;',
  'var interval = 25;',
  'var currentBeat = 0;',
  'var fadingStartBeat = -1;',
  'self.onmessage = function(e) {',
  '  var data = e.data;',
  '  if (data === "start") {',
  '    currentBeat = 0;',
  '    if (timerID) clearInterval(timerID);',
  '    timerID = setInterval(function() {',
  '      currentBeat++;',
  '      var isSilent = (fadingStartBeat > 0 && currentBeat > fadingStartBeat);',
  '      self.postMessage({ type: "tick", beat: currentBeat, isSilent: isSilent });',
  '    }, interval);',
  '  } else if (data === "stop") {',
  '    if (timerID) clearInterval(timerID);',
  '    timerID = null;',
  '    currentBeat = 0;',
  '  } else if (data.interval) {',
  '    interval = data.interval;',
  '  } else if (data.fadingBeat !== undefined) {',
  '    fadingStartBeat = data.fadingBeat;',
  '  }',
  '};'
].join('\n');
